import { CommonModule } from '@angular/common'
import { Component, CUSTOM_ELEMENTS_SCHEMA, effect, input, ViewEncapsulation } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { MatDividerModule } from '@angular/material/divider'
import { MatIconModule } from '@angular/material/icon'
import { MarkdownModule } from 'ngx-markdown'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { Note } from '../../models/main/note'
import { DdcDicSComponent } from '../ddc-dic-s/ddc-dic-s.component'
import { DdcPrivacyComponent } from '../ddc-privacy/ddc-privacy.component'
import { DdcProfilePicComponent } from '../ddc-profile-pic/ddc-profile-pic.component'
import { DdcTextGradientComponent } from '../ddc-text-gradient/ddc-text-gradient.component'

@Component({
  selector: 'ddc-read-note-mobile-sheet',
  templateUrl: './ddc-read-note-mobile-sheet.component.html',
  styleUrls: ['./ddc-read-note-mobile-sheet.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [
    AngularMaterialsModules,
    CommonModule,
    MatIconModule,
    MatDividerModule,
    DdcDicSComponent,
    DdcPrivacyComponent,
    DdcTextGradientComponent,
    DdcProfilePicComponent,
    MarkdownModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DdcReadNoteMobileSheetComponent {
  note = input<Note>(undefined)

  // Profile picture properties
  _dynamicRoute: string = ''
  _isProfilePicLoading: boolean = false
  _userProfilePic: string = ''

  _isDarkTheme = false
  _isLightTheme = true
  _isPaperTheme = false

  constructor(
    private readDialogRef: MatDialogRef<DdcReadNoteMobileSheetComponent>,
    private _themeService: ThemeService,
  ) {
    this._themeService.theme$.subscribe(theme => {
      this._isDarkTheme = theme === 'dark-theme'
      this._isLightTheme = theme === 'light-theme'
      this._isPaperTheme = theme === 'paper-theme'
    })

    // React to note changes
    effect(() => {
      this.setupProfilePicData()
    })
  }

  private setupProfilePicData(): void {
    // This will need to be updated based on how you get the user data
    // For now, setting default values
    const currentNote = this.note()
    if (currentNote?.owner) {
      this._dynamicRoute = `/users/${currentNote.owner.username || ''}`
      this._userProfilePic = currentNote.owner.profile_pic || ''
      this._isProfilePicLoading = false
    }
  }

  protected onProfilePicClick(): void {
    this.readDialogRef.close()
  }
}
